import type { ReactNode } from 'react';
import { Fragment } from 'react';

export type DetailRow = string | { label: string; value: string };

/* Rows arrive as label/value pairs so the label can carry meaningful emphasis;
   splitting rendered strings on ":" would wrongly bold times, URLs, and fee names. */
export const renderDetailRows = (rows?: Array<DetailRow>): Array<ReactNode> =>
  (rows ?? []).map((row, index) =>
    typeof row === 'string' ? (
      row
    ) : (
      <Fragment key={index}>
        <strong>{row.label}:</strong>
        {row.value ? ` ${row.value}` : null}
      </Fragment>
    ),
  );
